import { Directive, ElementRef, Input } from '@angular/core';
import { TableColumnFilterItem } from '../domain/types';

@Directive({
  selector: 'option=[psUiTableColumnOption]',
})
export class TableColumnHeaderOptionDirective {
  @Input()
  public group?: string;

  constructor(private element: ElementRef<HTMLOptionElement>) {}

  public option(): TableColumnFilterItem {
    const text = this.element.nativeElement.innerHTML.trim();
    const value = this.element.nativeElement.value.trim();

    return { text, value };
  }
}
